export default {
  archives: [],
  pagination: {},
  archive: {}
}
